import ModalStyledLoader from 'components/Elements/ModalStyledLoader'
import { Button, Col, Container, Image, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useHistory, useParams } from 'react-router-dom'

import addPromptsImg from 'assets/images/FaBookMedical.svg'
import updateMainAuthorImg from 'assets/images/MdContactMail.svg'
import addPersonImg from 'assets/images/MdPersonAdd.svg'
import updateBookInfoImg from 'assets/images/RiEditFill.svg'
import { useDashTour } from 'sections/Dashboard/hooks'

function CompleteSetup({
  projectInfoUpdateComplete,
  authorUpdateComplete,
  promptsUpdateComplete,
  invitesUpdateComplete,
  invitesCount,
}) {
  const launchTour = useDashTour()
  const history = useHistory()
  const { t } = useTranslation()
  const { bookId } = useParams()

  return (
    <div className="card-body-container card-body-save-container">
      <div className="card card-body">
        <div className="progressbar-container progressbar-box">
          <div className="text-left">
            <Container
              className={
                projectInfoUpdateComplete
                  ? 'customContainer customContainerPadding'
                  : 'customContainer'
              }
            >
              <Row>
                <Col md={{ span: 3 }}>
                  <div className="story-img">
                    <Image className="" src={updateBookInfoImg}></Image>
                  </div>
                </Col>
                <Col md={{ span: 9 }}>
                  {projectInfoUpdateComplete ? (
                    <div className="description">{t('updated_book_info')}</div>
                  ) : (
                    <ModalStyledLoader isglobal={false} />
                  )}
                </Col>
              </Row>
            </Container>

            <Container
              className={
                authorUpdateComplete
                  ? 'customContainer customContainerPadding'
                  : 'customContainer'
              }
            >
              <Row>
                <Col md={{ span: 3 }}>
                  <div className="story-img">
                    <Image className="" src={updateMainAuthorImg}></Image>
                  </div>
                </Col>
                <Col md={{ span: 9 }}>
                  {authorUpdateComplete ? (
                    <div className="description">
                      {t('updated_primary_author')}
                    </div>
                  ) : (
                    <ModalStyledLoader isglobal={false} />
                  )}
                </Col>
              </Row>
            </Container>

            <Container
              className={
                invitesUpdateComplete
                  ? 'customContainer customContainerPadding'
                  : 'customContainer'
              }
            >
              <Row>
                <Col md={{ span: 3 }}>
                  <div className="story-img">
                    <Image className="" src={addPersonImg}></Image>
                  </div>
                </Col>
                <Col md={{ span: 9 }}>
                  {invitesUpdateComplete ? (
                    <div className="description">
                      {t('add')} {invitesCount} {t('new_people')}
                    </div>
                  ) : (
                    <ModalStyledLoader isglobal={false} />
                  )}
                </Col>
              </Row>
            </Container>

            <Container
              className={
                promptsUpdateComplete
                  ? 'customContainer customContainerPadding'
                  : 'customContainer'
              }
            >
              <Row>
                <Col md={{ span: 3 }}>
                  <div className="story-img">
                    <Image className="" src={addPromptsImg}></Image>
                  </div>
                </Col>
                <Col md={{ span: 9 }}>
                  {promptsUpdateComplete ? (
                    <div className="description">
                      {t('updated_story_prompts')}
                    </div>
                  ) : (
                    <ModalStyledLoader isglobal={false} />
                  )}
                </Col>
              </Row>
            </Container>

            <div className="complete-guide-btns mt-5">
              <Button className="btn-blue mr-3" onClick={launchTour}>
                {t('take_a_dashboard_tour')}
              </Button>

              <div>
                <Button
                  className="btn-blue"
                  onClick={() => history.push(`/dashboard/book/${bookId}/info`)}
                >
                  {t('close_guide')}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CompleteSetup
